module.exports = __webpack_public_path__ + "img/图层 16.970b8b24.png";